import React from 'react';
import { LocaleString } from '@biw/intl';
import { ProgramModel } from '@biw/contests-core/lib/dux/programs';

interface Props {
    program: ProgramModel;
    calendarLabel: string;
}

const LastDayLeft = ( { program, calendarLabel }: Props ) => (
    program.isGoalSelection ? (
        <span className="to-select-label">
            <LocaleString data-sel="goal-selection-calendar-label" code={calendarLabel} />
        </span>
    ) : (
        null
    )
);

export default LastDayLeft;
